<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VmG77c/tc-custom/9781452141503.jpg?1712387998460" alt="This image is the cover for the book Are You Dissing Me?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Are You Dissing Me?
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An illustrated and humorous look into the innermost thoughts of animals, who turn out to be a lot like humans.</b></p> A hippo worries that her MFA is totally useless. A cardinal has roommate problems. A hummingbird is eager to join a social network. A bush baby teeters on the edge (<i>You wanna throw down?!</i>) Here for the first time are the innermost thoughts of our furry and feathered friends, who—it is finally revealed—humorously share the same anxieties, frustrations, and preoccupations as we do. Whether it’s a raccoon fretting about his judgmental friends, a buffalo impatiently waiting for his dumplings, or a sloth contemplating a career in stand-up comedy, each colorfully illustrated critter captures a moment of modern flux—and together they create an irresistibly funny portrait of a kingdom both wild and amusingly familiar. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Winheld
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4ced506